import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import "../components/Home/Sidebar/main.css";

import Dashboard from "../components/Home/Dashboard/Dashboard";
import Survey from "../components/Home/Survey/Survey";
import Responses from "../components/Home/Responses/Responses";
import CreateSurvey from "../components/Home/Survey/create-survey/create-survey";
import Login from "../components/Login/Login";
import Header from "../components/Home/Header/Header";
import Sidebar from "../components/Home/Sidebar/Sidebar";
import Footer from "../components/Home/Footer/Footer";
import EditSurvey from "../components/Home/Survey/edit-survey/edit-survey";
import { useDispatch } from "react-redux";
import { fetchLoginDetails } from "../components/Login/login-store/login-actions-creators";
import { createBrowserHistory } from "history";

const getStoredUser = () => {
  return JSON.parse(localStorage.getItem("Authentication") || "{}");
};

const getDefaultHomePath = () => {
  const storedUser = getStoredUser();
  return Number(storedUser?.user_role) === 2 ? "/home/response" : "/home/dashboard";
};

const hasRoleAccess = (allowedRoles) => {
  const storedUser = getStoredUser();
  return allowedRoles.includes(Number(storedUser?.user_role));
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = localStorage.getItem("Authentication") !== null;
  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchLoginDetails(JSON.parse(localStorage.getItem("Authentication"))));
    }
  }, [dispatch, isAuthenticated]);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

const RoleRoute = ({ component: Component, allowedRoles, ...rest }) => {
  const isAuthenticated = localStorage.getItem("Authentication") !== null;
  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchLoginDetails(JSON.parse(localStorage.getItem("Authentication"))));
    }
  }, [dispatch, isAuthenticated]);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          hasRoleAccess(allowedRoles) ? (
            <Component {...props} />
          ) : (
            <Redirect to={getDefaultHomePath()} />
          )
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

const AppRoutes = () => {
  const history = createBrowserHistory();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("Authentication") !== null;
    if (!isAuthenticated) {
      localStorage.clear();
    }
  }, []);

  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/login" component={Login} />
        <PrivateRoute path="/home" component={HomeRoutes} />
        <Redirect to="/login" />
      </Switch>
    </Router>
  );
};

const HomeRoutes = ({ match }) => {
  return (
    <>
      <Header />
      <Sidebar />
      <Switch>
        <Route exact path={match.path}>
          <Redirect to={getDefaultHomePath()} />
        </Route>

        <RoleRoute
          exact
          path={match.path + "/dashboard"}
          component={Dashboard}
          allowedRoles={[1]}
        />

        <RoleRoute
          exact
          path={match.path + "/survey"}
          component={Survey}
          allowedRoles={[1]}
        />

        <RoleRoute
          exact
          path={match.path + "/response"}
          component={Responses}
          allowedRoles={[1, 2]}
        />

        <RoleRoute
          exact
          path={match.path + "/survey/create-survey"}
          component={CreateSurvey}
          allowedRoles={[1]}
        />

        <RoleRoute
          exact
          path={match.path + "/survey/edit-survey/:id"}
          component={EditSurvey}
          allowedRoles={[1]}
        />

        <Redirect to={getDefaultHomePath()} />
      </Switch>
      <Footer />
    </>
  );
};

export default AppRoutes;